import PropTypes from "prop-types";

import { Button } from "@/components/ui/button";
import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { useContactNavigation } from "routes/contact/useContactNavigation";

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.entityContact.create,
  ACL_RELATIONSHIPS.entityForFilters.read,
];

/** The table's create action, preset with the parent the table is scoped by. */
const NewContactButton = ({ entityId, campaignId }) => {
  const { openCreate } = useContactNavigation();

  return (
    <Authorized permissions={CREATE_ACLS}>
      <Button
        size="sm"
        className="item-adder"
        onClick={() => openCreate({ entityId, campaignId })}
      >
        New Contact
      </Button>
    </Authorized>
  );
};

const idType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

NewContactButton.propTypes = {
  entityId: idType,
  campaignId: idType,
};

export default NewContactButton;
